document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('#contactTabs .nav-link');
    const backButtons = document.querySelectorAll('.back-button');

    tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
            e.preventDefault();
            const target = tab.getAttribute('data-bs-target');
            const tabContent = document.querySelector(target);
            const activeTab = document.querySelector('.nav-link.active');
            const activeTabContent = document.querySelector('.tab-pane.active');

            activeTab.classList.remove('active');
            tab.classList.add('active');
            activeTabContent.classList.remove('active', 'show');
            tabContent.classList.add('active', 'show');

            // No mobile, esconda as abas e mostre o conteúdo
            if (window.innerWidth <= 768) {
                document.getElementById('contactTabs').style.display = 'none';
                document.getElementById('contactTabsContent').style.display = 'block';
            }
        });
    });

    backButtons.forEach(button => {
        button.addEventListener('click', function () {
            // No mobile, mostre as abas e esconda o conteúdo
            if (window.innerWidth <= 768) {
                document.getElementById('contactTabs').style.display = 'flex';
                document.getElementById('contactTabsContent').style.display = 'none';
            }
        });
    });
});
